import React from "react";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";

import Footer from "../Home/Footer";
import FormContact from "../Home/FormContact";

import AuthIcons from "../../hooks/AuthIcons";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useUser } from "../../contexts/UserContext";

import JudoPresenceProHero from "./components/JudoPresenceProHero";
import JudoPresenceProHighlights from "./components/JudoPresenceProHighlights";
import JudoPresenceProFeatures from "./components/JudoPresenceProFeatures";
import JudoPresenceProPricing from "./components/JudoPresenceProPricing";
import JudoPresenceProGallery from "./components/JudoPresenceProGallery";

export default function JudoPresencePro() {
  useScrollToTop();

  const { user } = useUser();

  return (
    <div className="min-h-screen bg-white text-slate-950 dark:bg-slate-950 dark:text-white">
      {!user ? <AuthIcons /> : null}

      <main>
        <JudoPresenceProHero />

        <JudoPresenceProHighlights />

        <JudoPresenceProFeatures />

        <JudoPresenceProPricing />

        <JudoPresenceProGallery />

        <section
          id="contact"
          className="scroll-mt-24 bg-white py-20 dark:bg-slate-950 sm:py-24"
        >
          <div className="mx-auto max-w-[1480px] px-4 sm:px-6 lg:px-8">
            <div className="grid gap-8 border-b border-slate-200 pb-10 dark:border-white/10 lg:grid-cols-[1fr_0.85fr] lg:items-end">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#0868f2] dark:text-blue-300">
                  Découvrir Judo Présence Pro
                </p>

                <h2 className="mt-5 text-4xl font-semibold leading-[1.08] tracking-[-0.04em] text-slate-950 dark:text-white sm:text-5xl lg:text-6xl">
                  Parlons de vos groupes
                  <span className="block text-[#0868f2] dark:text-blue-300">
                    et de votre organisation.
                  </span>
                </h2>
              </div>

              <div className="max-w-xl lg:justify-self-end">
                <p className="text-base leading-8 text-slate-600 dark:text-slate-300">
                  Présentez-moi le nombre de dojos, de groupes et
                  d’adhérents de votre club. Je vous aiderai à choisir
                  la formule adaptée.
                </p>

                <a
                  href="tel:+33680727707"
                  className="group mt-6 inline-flex items-center gap-4 text-slate-950 dark:text-white"
                >
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-blue-50 text-[#0868f2] transition group-hover:bg-[#0868f2] group-hover:text-white dark:bg-blue-500/10 dark:text-blue-300">
                    <FaPhoneAlt />
                  </span>

                  <span>
                    <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">
                      Contact direct
                    </span>

                    <span className="mt-1 flex items-center gap-2 text-lg font-semibold">
                      06.80.72.77.07

                      <FaArrowRight className="text-[10px] text-[#ff7900] transition-transform group-hover:translate-x-1" />
                    </span>
                  </span>
                </a>
              </div>
            </div>

            <div className="mt-12">
              <FormContact />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}